'use client';

import { TextField } from '@mui/material';
import { CSSProperties } from 'react';

import { styled } from '../../styles';
import { Theme } from '../../theme';
import { MEDIUM_INPUT_HEIGHT, SMALL_INPUT_HEIGHT } from '../../theme/constants';
import { Typography } from '../Typography';

import { StyledTextFieldProps } from './types';

const getPadding = (props: StyledTextFieldProps & { theme: Theme }) => {
  const { size, theme } = props;

  if (size === 'small') {
    return theme.spacing(2);
  }

  return theme.spacing(3);
};

const getTypographyProps = (props: StyledTextFieldProps & { theme: Theme }) => {
  const { size, theme } = props;

  if (size === 'small') {
    return theme.typography.body3;
  }

  return theme.typography.body2;
};

const getHeight = (props: StyledTextFieldProps) => {
  const { size } = props;

  if (size === 'small') {
    return `${SMALL_INPUT_HEIGHT}px`;
  }

  return `${MEDIUM_INPUT_HEIGHT}px`;
};

export const StyledTextField = styled(TextField)<StyledTextFieldProps>(
  (props) => ({
    '& .MuiInputBase-root': {
      height: getHeight(props),
    },

    '& .MuiInputBase-input': {
      padding: 0,
      ...(getTypographyProps(props) as CSSProperties),

      '&::placeholder': {
        color: props.theme.palette.text3,
      },

      '&::-webkit-outer-spin-button,::-webkit-inner-spin-button': {
        appearance: 'none',
        margin: 0,
      },

      '&[type=number]': {
        appearance: 'textfield',
      },
    },

    '.MuiOutlinedInput-root': {
      padding: getPadding(props),
    },
  }),
);

export const TextFieldContainer = styled.div(
  () =>
    ({
      width: '100%',
      position: 'relative',
    } as const),
);

export const ErrorMessage = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  bottom: -16,
  color: theme.palette.error.main,
}));
